import React from "react";
import { useHistory } from "react-router";
import { useDataMap } from "../../../../../common/hooks/api/useDataMap";
import { usePrimaryOrganizationId } from "../../../../hooks";
import { useCollectionGroups } from "../../../../hooks/useCollectionGroups";
import { useDisclosuresForCollectionGroups } from "../../../../hooks/useDisclosuresForCollectionGroups";
import { lexicalJoin } from "../../../../util/text";
import { CollectionGroupType } from "../../../../../common/service/server/controller/CollectionGroupsController";
import { CollectionContext } from "../../../../../common/service/server/dto/OrganizationDataRecipientDto";
import { Stack } from "@mui/material";
import { DataRecipientDisclosureCards } from "../../../../components/organisms/DataRecipientCollectionCards";
import { TodoListCallout } from "../../../../components/organisms/TodoListCallout";
import { Routes } from "../../../../root/routes";
import { NetworkRequest } from "../../../../../common/models";
import { PageLoading } from "../../../../components";
import { EmployeePageWrapper } from "./EmployeePageWrapper";

const COLLECTION_GROUP_TYPE: CollectionGroupType[] = ["EMPLOYMENT"];
const CONTEXT: CollectionContext[] = ["EMPLOYEE"];

export function EmployeeDisclosuresPage() {
  const history = useHistory();

  const orgId = usePrimaryOrganizationId();
  const [groups, groupsRequest] = useCollectionGroups(orgId, COLLECTION_GROUP_TYPE);

  const disclosureData = useDisclosuresForCollectionGroups(orgId, groups, CONTEXT);

  const {
    data: dataMap,
    request: dataMapRequest,
    mutators: { patch },
  } = useDataMap(orgId);

  const groupLabel = groups ? lexicalJoin(groups.map((g) => g.name)) : "your employment groups";

  const isSaving = NetworkRequest.anyRunning(patch);

  if (groupsRequest.running || dataMapRequest.running) {
    return <PageLoading />;
  }

  return (
    <EmployeePageWrapper
      selectedTabKey="employee-disclosures"
      isSaving={isSaving}
      saveRequest={patch}
      nextOnClick={() => history.push(Routes.hrCenter.hrDataMap.employeeSources)}
      nextDisabled={!disclosureData.pendingComplete || isSaving}
      nextDisabledTooltip={
        isSaving
          ? "Changes are currently being saved"
          : "Please indicate disclosures for each vendor before continuing."
      }
    >
      <div className="tw-boundary" style={{ marginBottom: "60px", maxWidth: "800px" }}>
        <h4 className="text-lg font-medium">
          What categories of information are collected, analyzed by, stored in, or otherwise
          processed by your Data Recipients?
        </h4>

        <p className="mt-2">
          Select the Data Recipients process information about {groupLabel}. For each Data Recipient
          you select, identify which categories of personal data they process, including any
          categories of digital information that may be collected and processed automatically.
        </p>
      </div>

      <div style={{ maxWidth: "800px" }}>
        <Stack spacing={3}>
          <DataRecipientDisclosureCards
            dataMap={dataMap}
            disclosureData={disclosureData}
            groups={groups}
            context={["EMPLOYEE"]}
            showPendingRecipients={true}
          />
          <TodoListCallout groups={disclosureData.unmappedDisclosurePICGroups} />
        </Stack>
      </div>
    </EmployeePageWrapper>
  );
}
